import { AtlasGrid } from "./AtlasGrid";
import { TextTexture } from "./TextTexture";
import { TextRenderConfig } from "./TextRenderConfig";
export class TextAtlas {
    constructor() {
        this.texWidth = 1024;
        this.texHeight = 1024;
        this.texture = null;
        this.charMaps = {};
        this.texHeight = this.texWidth = TextRenderConfig.atlasWidth;
        this.texture = TextTexture.getTextTexture(this.texWidth, this.texHeight);
        if (this.texWidth / TextRenderConfig.atlasGridW > 256) {
            TextRenderConfig.atlasGridW = Math.ceil(this.texWidth / 256);
        }
        this.atlasgrid = new AtlasGrid(this.texWidth / TextRenderConfig.atlasGridW, this.texHeight / TextRenderConfig.atlasGridW, this.texture.id);
    }
    setProtecteDist(d) {
    }
    getAEmpty(w, h, pt) {
        var find = this.atlasgrid.addRect(1, Math.ceil(w / TextRenderConfig.atlasGridW), Math.ceil(h / TextRenderConfig.atlasGridW), pt);
        if (find) {
            pt.x *= TextRenderConfig.atlasGridW;
            pt.y *= TextRenderConfig.atlasGridW;
        }
        return find;
    }
    get usedRate() {
        return this.atlasgrid._used;
    }
    updateTextureUsage() {
        this.texture.touchTexture();
        for (var k in this.charMaps) {
            var ri = this.charMaps[k];
            if (ri.referenceCount > 0) {
                ri.touch();
            }
        }
    }
    destroy() {
        for (var k in this.charMaps) {
            var ri = this.charMaps[k];
            ri.deleted = true;
        }
        this.texture.discard();
    }
    printDebugInfo() {
    }
}
